import { render, staticRenderFns } from "./ControversyModal.vue?vue&type=template&id=513423c2&scoped=true&"
import script from "./ControversyModal.vue?vue&type=script&lang=js&"
export * from "./ControversyModal.vue?vue&type=script&lang=js&"
import style0 from "./ControversyModal.vue?vue&type=style&index=0&id=513423c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513423c2",
  null
  
)

export default component.exports